<template>
  <div
    class="px-6 2xl:px-24 py-40"
  >
    <span id="faqs" class="max-w-4xl h3 text-black mb-24 block">
      {{ $t("faqs") }}
    </span>
    <div>
      <nv-collapse>
        <nv-collapse-item
          v-for="(faq, idx) in data"
          :key="faq.id"
        >
          <div slot="header" class="nv-d-flex nv-align-items-center nv-justify-content-between">
            <span class="flex faq-title">
              {{ faq.title }}
            </span>
            <nv-icon>expand-more</nv-icon>
          </div>
          <div slot="content" class="mobile-navigation-links nv-mb-2">
            <Markdown :content="faq.markdown || '{}'" :show-nav="false"></Markdown>
          </div>
        </nv-collapse-item>
      </nv-collapse> 
    </div>
  </div>
</template>
<script lang="ts" setup>
// Packages
import type { IPayloadCMSFaqs } from '~/server/api/products/[slug]/types';

// -----------------------------------
// Props
// -----------------------------------

const props = defineProps({
  productSlug: {
    type: String,
    required: true,
  },
});

// -----------------------------------
// Hooks
// -----------------------------------
const { localeProperties } = useI18n();
const {status, error, data } = await useFetch<IPayloadCMSFaqs['docs']>(`/api/products/${props.productSlug}/faq?language_code=${localeProperties.value.language}`,
  {
    key: `productsFaqs:${props.productSlug}:${localeProperties.value.language}`,
    lazy: true,
    immediate: true,
  }
);

// -----------------------------------
// Methods
// -----------------------------------

</script>
<style lang="scss" scoped>
.faq-collapse {
  display: block;
  margin: auto;
  max-width: 840px;
}

.faqs a {
  padding: unset;
}

.faq-title {
  font-size: 22px;
  line-height: 30px;

  font-family: 'FiraGO Regular' !important;
}

@media (screen(lg)) {

  .faq-title {
    font-size: 32px;
    line-height: 40px;
  }
}
</style>
